import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PasajerosService } from 'src/app/_services/pasajeros.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPasajerosDetallesComponent } from '../modal-pasajeros-detalles/modal-pasajeros-detalles.component';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';
import * as xlsx from 'xlsx';

@Component({
  selector: 'app-pasajeros-admin',
  templateUrl: './pasajeros-admin.component.html',
  styleUrls: ['./pasajeros-admin.component.css']
})
export class PasajerosAdminComponent implements OnInit {
  form: FormGroup;
  import: FormGroup;
  listPasajeros = [];
  cantidad: number;
  pageOfItems: Array<any>;

  constructor(
    private formBuilder:FormBuilder,
    private modalService:NgbModal,
    private pasajerosService:PasajerosService,
    private auxService:AuxiliarService,
  ) { }

  ngOnInit(): void {
    this.cantidad = 0;
    this.form = this.formBuilder.group({
      search: [''],
      destino: [''],
      fecha: [''],
      sinpago: [false],
      pagoparcial: [false],
      pagototal: [false],
    });
    //cargar listado filtrado de pasajeros
    this.pasajeros();

    const input = (<HTMLInputElement>document.getElementById('excelfile'));
    input.addEventListener("change", this.handleImportExcelFileAsync.bind(this), false);
  }

  pasajeros(){
    this.listPasajeros = [];
    this.pasajerosService.pasajerosSearch(this.f).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.cantidad = data.body.count;
        this.listPasajeros = data.body.list;
      }

    });
  }

  ordenarItems(node): void {
    this.listPasajeros = this.listPasajeros.slice().reverse();
    // this.listPasajeros.sort(function(a,b) {
    // if(a.nombre_pasajero > b.nombre_pasajero )
    //   return -1;
    // else if(a.nombre_pasajero < b.nombre_pasajero )
    //   return 1;
    // else
    //   return 0;
    // });
  }

  onChangePage(pageOfItems: Array<any>) {
      // update current page of items
      this.pageOfItems = pageOfItems;
  }

  get f() { return this.form.controls; }

  onSubmit() { //devuelve una lista con el id y el mombre de la agencia
    this.pasajeros();
  }

  statusPago(item){
    if(item.pagado == 0)
      return "Pago Nulo";
    else if(item.pagado == item.precio)
      return "Pago Total";
    else if(item.pagado < item.precio)
      return "Pago Entregado";
    else
      return "Error Pago Excedido";
  }

  formatoFecha(fecha){
    if(fecha !== null && fecha !== undefined) {
      var fe = fecha.split("T")[0].split("-");
      return fe[2]+"/"+fe[1]+"/"+fe[0];
    } else
      return "";
  }

  unformatFecha(fecha){
    if(fecha !== null && fecha !== undefined) {
      var fe = fecha.split("/");
      return fe[2]+"-"+fe[1]+"-"+fe[0];
    } else
      return "";
  }

  formatoDocumento(documento){
    return documento.replace(/\B(?=(\d{3})+(?!\d))/g,".");
  }

  async handleImportExcelFileAsync(){
    const input = (<HTMLInputElement>document.getElementById('excelfile'));
    const file = input.files[0];
    const data = await file.arrayBuffer();
    const workbook = xlsx.read(data);
    const json = xlsx.utils.sheet_to_json(workbook.Sheets.data);
    this.pasajerosService.pasajerosImport(json).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        const modalRef = this.modalService.open(ModalMsgComponent, {
          centered: true,
          backdrop:'static',
        });
        modalRef.componentInstance.label = 'Aceptar';
        if(response.msg === "PASAJERO_IMPORT_SUCCESS") {
          modalRef.componentInstance.titulo = 'Importado Exitoso';
          modalRef.componentInstance.texto = "Se ha importado el archivo excel con exito";
          modalRef.componentInstance.check = 0;
          console.log(response);
        } else {
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';
          // var error_code = "<b>"+response.code+"</b><br>";
          // modalRef.componentInstance.texto = error_code+response.details.replace("\n","<br>");
          modalRef.componentInstance.check = 0;
          console.log(response);
        }

        this.pasajeros();
      }
    });
  }

  importExcel() {
    const input = (<HTMLInputElement>document.getElementById('excelfile'));
    input.click();
  }

  exportExcel() {
    var listP = this.listPasajeros.map(x => { return {...x}})
                  .map(x => {
                       x.fecha = this.formatoFecha(x.fecha);
                       x.fecha_nacimiento = this.formatoFecha(x.fecha_nacimiento);
                       return x;
                  });
    const worksheet = xlsx.utils.json_to_sheet(listP);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, "pasajeros");
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  async openPasajerosDetalles(item) {
    let modalRef = this.modalService.open(ModalPasajerosDetallesComponent, {
      centered: true,
      backdrop:'static',
    });
    modalRef.componentInstance.pasajero = item;

    var callback = function (result) {
      this.pasajeros();
    };

    await modalRef.result.then(callback.bind(this), () => {});
    return;
  }

}
